import styles from './SubscriptionModal.module.css';
import { createPortal } from 'react-dom';
import { Loader } from '@/components/Loader/Loader';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { getAdsgramBanTime } from '@/api/modules/AdsgramBan/adsgramban';

interface AdWidgetModalProps {
  isOpen: boolean;
  isClosing: boolean;
  onClose: () => void;
  onReward: () => void;
  onAdsNotFound: () => void;
  checkOnly?: boolean;
}
declare module 'react' {
  namespace JSX {
    interface IntrinsicElements {
      'adsgram-task': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      > & {
        'data-block-id'?: string;
        style?: React.CSSProperties;
        ref?: React.Ref<any>;
      };
    }
  }
}
const AdsgramWidgetModal = function AdsgramWidgetModal({
  isOpen,
  isClosing,
  onClose,
  onReward,
  onAdsNotFound,
  checkOnly,
}: AdWidgetModalProps) {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isAdsgramTaskReady, setIsAdsgramTaskReady] = useState<boolean>(false);
  const taskRef = useRef<any>(null);
  const [isBan, setIsBan] = useState<boolean>(true);
  useEffect(() => {
    const isban = async () => {
      const res = await getAdsgramBanTime();
      console.log('res', res);
      setIsBan(res.answer);
    };
    isban();
  }, []);

  // Ждём 5 секунд после регистрации компонента, чтобы понять — есть ли задача или нет
  useEffect(() => {
    if (!isOpen) return;

    let readyTimeout: NodeJS.Timeout | null = null;
    let adsCheckTimeout: NodeJS.Timeout | null = null;

    function checkReady() {
      if (customElements.get('adsgram-task')) {
        console.log('isBan', isBan);

        setIsAdsgramTaskReady(false); // пока не показываем task
        setIsLoading(true);

        // Ждём 5 секунд — если не пришёл adsnotfound, показываем task
        adsCheckTimeout = setTimeout(() => {
          setIsAdsgramTaskReady(true);
          setIsLoading(false);
        }, 5000);
      } else {
        readyTimeout = setTimeout(checkReady, 100);
      }
    }

    checkReady();

    return () => {
      if (readyTimeout) clearTimeout(readyTimeout);
      if (adsCheckTimeout) clearTimeout(adsCheckTimeout);
    };
  }, [isOpen]);

  // Обработка событий adsgram-task
  useEffect(() => {
    if (!customElements.get('adsgram-task') || !taskRef.current) return;
    const task = taskRef.current;

    const handleReward = (event: any) => {
      onReward();
    };

    const handleAdsNotFound = (event: any) => {
      onAdsNotFound();
      setIsLoading(false);
      setIsAdsgramTaskReady(false); // не показываем task
    };
    const handleTooLongSession = (event: any) => {
      onAdsNotFound();
      setIsLoading(false);
      setIsAdsgramTaskReady(false); // не показываем task
    };

    task.addEventListener('reward', handleReward);
    task.addEventListener('onBannerNotFound', handleAdsNotFound);
    task.addEventListener('onTooLongSession', handleTooLongSession);

    return () => {
      task.removeEventListener('reward', handleReward);
      task.removeEventListener('onBannerNotFound', handleAdsNotFound);
      task.removeEventListener('onTooLongSession', handleTooLongSession);
    };
  }, [isOpen, onReward, onAdsNotFound]);

  useEffect(() => {
    if (!isBan) {
      onAdsNotFound();
      setIsLoading(false);
      setIsAdsgramTaskReady(false);
    }
  }, [isBan]);

  const handleSkipTask = useCallback(() => {
    onAdsNotFound();
    setIsLoading(false);
    setIsAdsgramTaskReady(false);
  }, [onAdsNotFound]);

  const handleCloseClick = useCallback(() => {
    onClose();
  }, [onClose]);

  if (!isOpen) return null;

  return createPortal(
    <div
      className={`${styles.modalWrapper}`}
      style={{ opacity: isLoading ? 0 : 1 }}
    >
      <div className={`${styles.modal} ${isClosing ? styles.slideDown : ''}`}>
        <div className={styles.modalContent}>
          {!checkOnly && (
            <button
              className={styles.closeButton}
              onClick={handleCloseClick}
            ></button>
          )}
          {!checkOnly && (
            <p className={styles.rewardText}>
              Нажми на Start, <br /> чтобы выполнить задание.
            </p>
          )}
          <div className={styles.task}>
            <adsgram-task
              data-block-id={'task-13128'}
              ref={taskRef}
              style={{ display: isAdsgramTaskReady ? 'block' : 'none' }}
            >
              <p className={styles.reward} slot="reward">
                Нажми на старт, чтобы продолжить
              </p>
              <button className={styles.button_go} slot="button">
                Start
              </button>
              <button className={styles.button_claim} slot="claim">
                Claim
              </button>
            </adsgram-task>
            {!isAdsgramTaskReady && <Loader />}
          </div>
          <div className={styles.skipTask} onClick={handleSkipTask}>
            Пропустить задание
          </div>
          {!checkOnly && (
            <div className={styles.rewardsModal}>
              <p className={styles.rewardText_warning}>
                *Остерегайтесь мошенников
                <br />
                Подписываться необязательно.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default AdsgramWidgetModal;
